import React from "react";
import "./Home.css";
import Product from "./Product";

function Home() {
  return (
    <div className="home">
      <div className="home__container">
        <img
          className="home__images"
          src="https://images-na.ssl-images-amazon.com/images/G/01/AmazonExports/Fuji/2020/May/Hero/Fuji_TallHero_Toys_en_US_1x._CB431858161_.jpg"
        />

        <div className="home__row">
          <Product
            id="1234567"
            title="CAHAYA Electric Guitar Bag Gig Bag 6mm Padding Backpack Padded Soft Guitar Case Black"
            image="https://m.media-amazon.com/images/I/61LkFtOXJBL._AC_UY218_.jpg"
            price={121.99}
            rating={4}
          />
          <Product
            id="7654321"
            title="YMC 30inch Kids Electric Guitar Pack With 5-Watt Amp, Gig Bag,Strap,Cable,Strings,Picks,and Wrench,Guitar Combo Accessory Kit-Black"
            image="https://m.media-amazon.com/images/I/71JPFNtkSaL._AC_UY218_.jpg"
            price={374.95}
            rating={4}
          />
        </div>

        <div className="home__row">
          <Product
            id="1111111"
            title="Save on Twelve South BookArc for MacBook | Space-Saving Vertical Desktop Stand for Apple notebook"
            image="https://images-na.ssl-images-amazon.com/images/I/31BaArdwnSL._AC_US218_.jpg"
            price={36.95}
            rating={4}
          />
        </div>

        <div className="home__row">
          <Product
            id="1111114"
            title="WAITIEE Wireless Charger, 3 in 1 Qi-Certified 15W Fast Charging Station for Apple iWatch Series 5/4/3/2/1,AirPods"
            image="https://m.media-amazon.com/images/I/71BrDm1ZtjL._AC_UY218_.jpg"
            price={28.99}
            rating={4}
          />
          <Product
            id="11113243"
            title="Crocs Kids' Crocband Clog | Slip On Shoes for Boys and Girls | Water Shoes"
            image="https://m.media-amazon.com/images/I/614UCUWgkZL._AC_UL320_.jpg"
            price={29.95}
            rating={5}
          />
        </div>
      </div>
    </div>
  );
}

export default Home;
